import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import SettingsStore from "@/stores/SettingsStore";
import { useTranslation } from "react-i18next";
import { ControlWrapper } from "@/components/ui/control-wrapper";

export function HistoryToggle() {
  const { t } = useTranslation();
  const displayHistory = SettingsStore(state => state.displayHistory);
  const setDisplayHistory = SettingsStore(state => state.setDisplayHistory);
  const isLoading = SettingsStore(state => state.isLoading);

  return (
    <ControlWrapper>
      <div className="flex items-center justify-between">
        <Label htmlFor="display-history">{t("settings.displayHistory")}</Label>
        <Switch
          id="display-history"
          checked={displayHistory}
          onCheckedChange={setDisplayHistory}
          disabled={isLoading}
        />
      </div>
    </ControlWrapper>
  );
}
